import * as React from 'react'

import LinkComponent from 'src/components/UI/LinkComponent/LinkComponent'
import { getBrandById } from 'src/utils/brand'

type Props = {
  children: any
  className?: any
  onClick?: any
  product: any
}

const ProductLink = ({ product, children, className, onClick }: Props) => {
  const brand = getBrandById(product.brand)
  if (!brand.slug) {
    return null
  }

  return (
    <LinkComponent
      onClick={onClick}
      to={`${brand.slug}/${product.uri}`}
      className={className}
    >
      {children}
    </LinkComponent>
  )
}

export default ProductLink
